/*
ge-captcha.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/forgot-password-popup/directives/ge-captcha/ge-captcha',['angular', 'geControlGroup', './ge-captcha-i18n'], function () {

    // Module Dependencies
    var dependencies = [
        'Directives.GeCaptcha.Services.i18n',
        'Directives.GeControlGroup'
    ];

    // Module Definition
    var mod = angular.module('Directives.GeCaptcha', dependencies);

    /*
    * @description
    * Provides the GE Captcha directive.
    *
  * @Param
    * captchaValue: captchaValue that will be passed up side alogn with service URL.
    * reloadCaptcha: Boolean flag to trigger loading of new captcha.
    * captchaGuid: Unique GUID that will be sent on each /captcha request. Generated on init of a directive.
    *
  * @example
    * <ge-captcha captcha-text="captchaValue" reload-captcha="reload" captcha-guid="guid"/>
    */
    mod.directive('geCaptcha', ['LoginForgotPassword.Captcha.i18n', function (i18n) {
        return {
            /**
             * Use the restrict option to specify how this directive can be applied to HTML elements.
             *  'A' = Attribute (e.g. <div my-directive>)
             *  'C' = Class     (e.g. <div class="my-directive">)
             *  'E' = Element   (e.g. <my-directive>)
             *  'M' = Comment   (e.g. <!-- directive: my-directive -->)
             */
            restrict: 'EA',
            /**
             * Use the template option to specify the directive element's inner HTML template.
             */
            templateUrl: 'assets/javascripts/login/modules/forgot-password-popup/directives/ge-captcha/ge-captcha.html',
            /**
             * Use the scope option to isolate this directive's scope from its parent's scope, allowing only the
             * specified data to be accessible within this directive's scope. This data is passed to the directive
             * via HTML element attributes.
             *
             *  '@' = Text binding    (data is a string; can use {{ }} syntax to evaluate expressions)
             *  '&' = One-way binding (data is a function; changes to data in the directive do not affect the parent)
             *  '=' = Two-way binding (data is of any type; changes to data in the directive affect the parent)
             */
            scope: {
                captchaValue: '=',
                reloadCaptcha: '=',
                captchaGuid: '='
            },
            /**
             * Use the `controller` function to define the directive's internal logic. You may also bind
             * properties/methods to the directive's scope or 'this'. The data bound to 'this' can be
             * made accessible in other directives using the require option.
             *
             * @param $scope   - the directive's scope object.
             * @param $element - the jqLite-wrapped element that this directive matches.
             * @param $attrs   - the matched element's attributes and their corresponding values.
             */
            controller: ['$scope', function ($scope) {
                // Collection of localized messages
                $scope.msg = i18n.getMessages();

                /**
                 * Loads a new captcha image.
                 */
                $scope.loadCaptcha = function () {
                    // Get a new captcha image
                    angular.element('#captchaImage').attr('src', '/captcha?uuid=' + $scope.captchaGuid + '&' + new Date().getTime());
                };

                /**
                 * Reloads the captcha image when an error is detected.
                 */
                $scope.$watch('reloadCaptcha', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.loadCaptcha();
                    }
                });

                /**
                 * Function to generate unique GUID.
                 */
                var getCaptchaGuid = (function () {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
                    }

                    return function () {
                        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
                    };
                })();

                // Scope variable to hold the GUID for the current captch session
                $scope.captchaGuid = getCaptchaGuid();
                $scope.loadCaptcha();
            }]
        };
    }]);

});

